'use client';

import { useRouter } from 'next/navigation';
import { ROUTES } from '#/data/constants';
import { Button } from '../ui/button';

export function UserLoginNav() {
  const router = useRouter();
  return (
    <Button
      onClick={() => {
        router.push(ROUTES.LOGIN);
      }}
      variant="outline"
      /*
        외곽선으로 둔다. 헤더에 채운 파란 알약이 '맞춤법 검사'와 둘이 되면
        시선이 갈려서, 주력 기능 쪽에 강조를 몰아 준다.
      */
      className="rounded-full px-6 border-[#104573]/30 bg-transparent text-[#104573] shadow-none transition-colors hover:bg-[#104573]/5 hover:text-[#104573] dark:border-white/25 dark:text-[#60a3d9] dark:hover:bg-white/5 dark:hover:text-[#60a3d9]"
    >
      <span>로그인</span>
    </Button>
  );
}
